export const setCodeValue = (state, data) => {
  state.CodeValue = data;  // 这里的CodeValue 需与index中的名字保持一致
};

export const setSignalRState = (state, data) => {
  state.SignalRState = data;
};

export const setDeviceStates = (state, data) => {
  state.DeviceStates = data;
};

export const setDeviceUnfold = (state, data) => {
  state.DeviceUnfold = data;
};

export const setUserState = (state, data) => {
  state.UserState = data;
};

export const setEnergyState = (state, data) => {
  state.EnergyState = data;
};

export const setDeviceAlarm = (state, data) => {
  state.DeviceAlarm = data;
};

export const setUseGasState = (state, data) => {
  state.UseGasState = data;
};

export const setUserItem = (state, data) => {
  state.UserItem = data;
};

export const setThemeCode = (state, data) => {
  state.ThemeCode = data;
};

export const setHomeType = (state, data) => {
  state.HomeType = data;
};



// WEBPACK FOOTER //
// ./src/store/mutations.js